module.exports = __webpack_public_path__ + "static/media/a2.5e10676.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lijunfeng/a2.mp3
// module id = /igA
// module chunks = 0